import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import type BlockSetup from 'webapp/models-custom/block-setup';
import type DataSelect from 'webapp/models-custom/data-select';

interface Args {
	model: DataSelect;
	isSelected: boolean;
	blockSetup?: BlockSetup;
	changeTab: (ds: DataSelect) => void;
}

export default class DataSelectEditTabComponent extends Component<Args> {
	get typeText(): string {
		let typeText = '';
		if (this.args.blockSetup) {
			typeText = this.args.blockSetup.getTypeTextForDataSelect(this.args.model);
		}
		return typeText;
	}
	<template>
		<li
			class={{if @isSelected "selected"}}
			role="button"
			data-id={{@model.id}}
			{{on "click" (fn @changeTab @model)}}
		>
			<span class="name-text">{{@model.shownTitle}}</span>
			<small>{{this.typeText}}</small>
		</li>
	</template>
}
